module.exports = __webpack_public_path__ + "static/Banner-3-2c39b4def14be39ddd06c1dd1218c502.png";